import { useEffect } from "react";
import { chrome } from "@/spiel/chrome";
import styles from "./DevtoolsGuard.module.scss";

const TENOR_SCRIPT = "https://tenor.com/embed.js";
const TENOR_POST_ID = "9603123417229412569";
const TENOR_HREF =
  "https://tenor.com/view/how-may-i-how-can-i-cat-sad-support-gif-9603123417229412569";

export const DevtoolsGuard = () => {
  useEffect(() => {
    const existing = document.querySelector(`script[src="${TENOR_SCRIPT}"]`);
    existing?.remove();

    const script = document.createElement("script");
    script.src = TENOR_SCRIPT;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <div className={styles.veil} role="alert" aria-label={chrome.devtoolsFreeze}>
      <div className={styles.meme}>
        <div
          className="tenor-gif-embed"
          data-postid={TENOR_POST_ID}
          data-share-method="host"
          data-aspect-ratio="1"
          data-width="100%"
        >
          <a href={TENOR_HREF}>{chrome.devtoolsFreeze}</a>
        </div>
      </div>
    </div>
  );
};
